
/**
 * Specify the display type for DMSMapping.
 * @since 4.0.0
 */
export enum MappingDisplayType {

    /**
     * Show both filters and grids (Default value).
     * @since 4.0.0
     */
    FilterAndGrids = 0,

    /**
     * Show only grids.
     * @since 4.0.0
     */
    GridsOnly = 1,

    /**
     * Show only filters.
     * @since 4.0.0
     */
    FiltersOnly = 2,
}
